import { tileColors } from '@osano/b2b/common/colors';

export default theme => ({
    // White floating card matching the design: green check + bold label, no
    // close button (the whole node is rendered via notistack's `content`, so
    // the provider's default variant styling and close action are bypassed).
    toast: {
        alignItems: 'center',
        display: 'inline-flex',
        gap: theme.spacing(1.5),
        padding: theme.spacing(1.5, 2.5),
        backgroundColor: theme.palette.background.paper,
        borderRadius: theme.shape.borderRadius * 2,
        boxShadow: theme.shadows[6],
        // notistack anchors this toast at the viewport centre (50%), but the
        // unsaved-changes bar is centred within a wrapper offset `left: 25%`,
        // so its centre sits at ~62.5%. Nudge the toast right by the matching
        // 12.5vw so it lines up under the bar.
        transform: 'translateX(12.5vw)',
    },
    icon: {
        color: tileColors.green.icon,
    },
    label: {
        color: theme.palette.text.primary,
        fontSize: 14,
        fontWeight: 600,
    },
});
